import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavBarButton from "../buttons/NavBarButton";
import { useAuth } from "../auth/FirebaseAuth";

import { useAppContext } from "../config/AppContext";

import SecondaryButton from "../buttons/SecondaryButton";

import { EasySwitch } from "../textfields/EasySwitch";
import { Spin } from "antd";
import TextField2 from "../textfields/TextField2";
import Space from "../layout/Space";
import Icon1 from "../assets/icons/Icon";
import imageLogo from "../assets/logo_flat.png"; // Adjust the path as necessary
import { Org, User } from "../types/basicTypes";

type NavBarProps = {
  actualpage: any;
  userData: User | null;
  orgData: Org | null;
  masterData: any;
  local_version: string;
  navigateWorkspace: (path: string, orgData?: Org) => void;
  handleLogout: (redirect_url: string) => Promise<void>;
  handleLoginAs: (id: string) => void;
};

function NavBar({
  actualpage,
  userData,
  orgData,
  masterData,
  local_version,

  navigateWorkspace,
  handleLogout,
  handleLoginAs,
}: NavBarProps) {
  const { currentUser, loading } = useAuth();
  const { appState, setAppState, resetAppStateLogin } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const location = useLocation();
  const [url, setUrl] = useState("http://127.0.0.1:8000/");

  const [messageNewVersion, setMessageNewVersion] = useState(false);
  const [client_notify, setClientNotify] = useState(false);
  const [vote_object, setVoteObject] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const [isProd, setIsProd] = useState(false);
  const [settings_open, setSettingsOpen] = useState<any>(null); // State to manage settings modal visibility

  useEffect(() => {
    setIsVisible(settings_open);
  }, [settings_open]);

  if (loading || !userData || !orgData) {
    return (
      <div className="flex flex-col items-center justify-center h-screen w-screen">
        <Spin size="small"></Spin>
      </div>
    ); // Show loading state while checking auth or if currentUser is null
  }

  // <div className="flex flex-row  max-w-full pl-1 mr-5 text-gray-800 text-h3  bg-neutral-100   rounded-md  border-1   ">
  //{orgData.name}
  // </div>

  return (
    <div className="flex flex-col  h-full w-64 min-w-64 bg-transparent pointer-events-auto p-2 ">
      {settings_open && (
        <div
          onClick={() => setSettingsOpen(false)}
          className="fixed h-screen w-screen  top-0 left-0  z-50 flex justify-center items-center"
        >
          <div
            className={`absolute bottom-4 z-40 w-c200 flex flex-col ${
              isVisible ? "scale-100 opacity-100 " : "scale-90 opacity-0"
            }  duration-75 transition-all   h-fit text-shadow_50 border-1 border-shadow_10  bg-white p-4 shadow-xl rounded-lg`}
            style={{ left: "230px" }}
          >
            <div className="flex flex-row gap-2 items-center ">
              <div className="h-10 w-10  min-h-10 min-w-10 rounded-full bg-indigo-50 flex items-center justify-center text-white">
                {settings_open.photo && (
                  <img
                    src={
                      settings_open.photo || "https://via.placeholder.com/150"
                    }
                    className="h-10 w-10 rounded-full"
                  ></img>
                )}
              </div>
              <div className="flex flex-col ">
                <div className="text-h3 font-semibold">
                  {settings_open.display_name}
                </div>
                <div className="text-h4 ">
                  {settings_open.email.substring(0, 15)}
                </div>
              </div>
            </div>
            {settings_open.niveau && (
              <div
                onClick={() => {
                  navigateWorkspace("/facturation?upgrade=true");
                  setSettingsOpen(false);
                }}
                className="flex flex-row cursor-pointer mt-4 gap-2  w-fit pr-4 items-center p-2 bg-primary rounded-lg"
              >
                <Icon1 icon_name="stars" size={20} fill="#ffffff" />
                <div className="text-h3 font-semibold text-white">
                  Mettre à niveau
                </div>
              </div>
            )}

            <div
              onClick={() => {
                navigateWorkspace("/account");
                setSettingsOpen(false);
              }}
              className="flex flex-row gap-2 w-full pr-4 mt-4 p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="user" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Compte</div>
            </div>
            <div
              onClick={() => {
                navigateWorkspace("/organisation");
                setSettingsOpen(false);
              }}
              className="flex flex-row gap-2 w-full pr-4 p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="organisation" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Entreprise</div>
            </div>

            <div
              onClick={() => {
                navigateWorkspace("/account");

                setSettingsOpen(false);
              }}
              className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="settings" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Paramètres</div>
            </div>
            <div
              onClick={() => handleLogout("")}
              className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="logout" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Déconnexion</div>
            </div>
          </div>
        </div>
      )}

      <div className="flex max-w-full h-full relative max-h-full  flex-col   rounded-md  ">
        <img
          src="https://i.pinimg.com/1200x/78/59/f4/7859f4e95c80233338160901a962475a.jpg"
          alt="Background"
          className="w-full h-full object-cover  rounded-3xl absolute "
        />
        <div className="relative flex flex-col pl-5 gap-1 flex-1 max-h-full  pr-4 max-w-full overflow-y-auto">
          <Space y={15} />
          <div className="flex flex-row gap-3 items-center ml-1">
            <div className="relative">
              <img src={imageLogo} alt="Logo" width={25} height={25} />
            </div>
            <div className="text-wshadow_75 select-none text-h2">
              easy <span className="font-semibold">ath</span>
            </div>{" "}
          </div>
          <Space y={20} />
          <div className="absolute top-1 right-1 text-h6 h-0 text-shadow_10 hover:text-shadow_50 duration-500">
            v.
            {local_version?.substring(6, 8) +
              "/" +
              local_version?.substring(4, 6) +
              "/" +
              local_version?.substring(8, 10) +
              "h" +
              local_version?.substring(10, 12)}
          </div>
          {/* Navigation buttons */}
          <NavBarButton
            icon="home"
            isActualPage={location.pathname.includes("home")}
            onClick={() => navigateWorkspace("/home", orgData)}
          >
            Accueil
          </NavBarButton>
          <NavBarButton
            icon="xml"
            isActualPage={location.pathname.includes("xml")}
            onClick={() => navigateWorkspace("/xmls", orgData)}
          >
            Xml
          </NavBarButton>
          <NavBarButton
            icon="file"
            isActualPage={location.pathname.includes("attestation")}
            onClick={() => navigateWorkspace("/attestations", orgData)}
          >
            Attestations
          </NavBarButton>
          <NavBarButton
            icon="user"
            isActualPage={location.pathname.includes("partner")}
            onClick={() => navigateWorkspace("/partners", orgData)}
          >
            Partenaires
          </NavBarButton>

          <NavBarButton
            icon="settings"
            onClick={() => {
              navigateWorkspace("/account", orgData);
            }}
            isActualPage={[
              "/account",
              "/organisation",
              "/facturation",
              "/options",
              "/atec",
              "/rtb",
              "/ath",
            ].includes(
              location.pathname.includes("workspace")
                ? "/" + location.pathname.split("workspace")[1].split("/")[2]
                : location.pathname
            )}
          >
            Paramètres
          </NavBarButton>

          {orgData.facturation?.plan === "free" && (
            <div
              onClick={() => {
                navigateWorkspace("/facturation");
              }}
              className={`
         
            flex flex-row items-center px-4 hover:bg-wshadow_25 w-full cursor-pointer p-1  rounded-lg gap-2 text-wshadow_50 text-h4 font-medium`}
            >
              <div className="bg-wshadow_50 h-1 rounded-full relative w-20">
                <div
                  style={{
                    width: `${
                      Math.min(orgData.counters?.attestations || 0, 5) * 20
                    }%`, // Assuming max is 10 attestations, adjust as needed
                  }}
                  className={`
                    ${
                      orgData.counters?.attestations >= 5
                        ? "bg-red-500"
                        : "bg-white"
                    }
                    absolute top-0 left-0 h-full  rounded-full transition-all duration-300 ease-in-out`}
                ></div>
              </div>{" "}
              {orgData.counters?.attestations || 0}/5
            </div>
          )}

          <Space y={30}></Space>
          {/* Admin-specific buttons */}
          {userData.admin && (
            <div className="flex flex-col ">
              <div className="flex flex-row items-center gap-2 p-0 m-0">
                <div className="text-h3 text-wshadow_75 font-medium">Local</div>
                <EasySwitch
                  checked={appState.dev}
                  onChange={(checked) =>
                    setAppState((prevState: any) => ({
                      ...prevState,
                      dev: checked,
                    }))
                  }
                />
              </div>{" "}
              <NavBarButton
                icon="logs"
                onClick={() => navigateWorkspace("/admin/logs", orgData)}
                isActualPage={location.pathname === "/admin/logs"}
              >
                Logs
              </NavBarButton>{" "}
              <NavBarButton
                icon="user"
                onClick={() => navigateWorkspace("/admin/users", orgData)}
                isActualPage={location.pathname === "/admin/users"}
              >
                Utilisateurs
              </NavBarButton>
              <NavBarButton
                icon="organisation"
                onClick={() => navigateWorkspace("/admin/orgs", orgData)}
                isActualPage={location.pathname === "/admin/orgs"}
              >
                Orgs
              </NavBarButton>
              <Space y={10}></Space>
            </div>
          )}
          <Space y={10}></Space>
        </div>
        <div className="flex flex-col justify-end    w-full relative ">
          <div
            onClick={() =>
              setSettingsOpen(
                settings_open
                  ? null
                  : {
                      display_name: userData?.display_name,
                      email: userData?.email,
                    }
              )
            }
            className="flex flex-row  select-none cursor-pointer max-w-full justify-between gap-3 p-2 m-2  items-center rounded-2xl hover:bg-wshadow_35 "
          >
            <div className="flex flex-row gap-3 max-w-full">
              <div className=" min-w-10 h-10 rounded-full bg-wshadow_35 flex justify-center relative"></div>
              <div className="flex flex-col flex-grow max-w-full ">
                <div className="text-h3 text-nowrap text-white text-ellipsis overflow-hidden select-none max-w-24">
                  {userData.display_name}
                </div>
                <div
                  className="text-h6 text-wshadow_75
            max-h-4  text-ellipsis overflow-hidden select-none max-w-24
              "
                >
                  {userData.email}
                </div>
              </div>{" "}
            </div>
            <div className="">
              <Icon1 icon_name="settings" size={20} fill="white"></Icon1>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

export default NavBar;
